import { motion, useReducedMotion } from 'motion/react'
import { COLORS, EASE_OUT, NEUTRAL1_RGB } from '../home/tokens'

/**
 * Small accessible on/off switch for a consent category. When `locked` (the
 * Necessary category) it renders permanently-on and non-interactive.
 */
export function CookieToggle({
  checked,
  onChange,
  locked = false,
  label,
}: {
  checked: boolean
  onChange?: (next: boolean) => void
  locked?: boolean
  label: string
}) {
  const reduce = useReducedMotion()
  const on = locked || checked

  return (
    <button
      type="button"
      role="switch"
      aria-checked={on}
      aria-label={label}
      disabled={locked}
      onClick={() => !locked && onChange?.(!checked)}
      style={{
        position: 'relative',
        width: 44,
        height: 24,
        flex: '0 0 auto',
        borderRadius: 999,
        border: 'none',
        padding: 2,
        cursor: locked ? 'default' : 'pointer',
        backgroundColor: on ? COLORS.green2 : `rgba(${NEUTRAL1_RGB},0.18)`,
        opacity: locked ? 0.6 : 1,
        transition: 'background-color 0.25s ease',
      }}
    >
      <motion.span
        aria-hidden
        animate={{ x: on ? 20 : 0 }}
        transition={reduce ? { duration: 0 } : { duration: 0.25, ease: EASE_OUT }}
        style={{
          display: 'block',
          width: 20,
          height: 20,
          borderRadius: '50%',
          backgroundColor: COLORS.neutral1,
        }}
      />
    </button>
  )
}
